import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { NewsComponent } from "../components/news/news.component";
import { EditorComponent } from "../components/editor/editor.component";
import { DashboardComponent } from "../components/dashboard/dashboard.component";
import { SourceMappingComponent } from "../components/source-management/source-mapping/source-mapping.component";
import { SourceManagementComponent } from "../components/source-management/source-management.component";
import { UserEditorComponent } from "../components/userComponents/user-editor/user-editor.component";
import { UserManagerComponent } from "../components/userComponents/user-manager/user-manager.component";
import { LoginComponent } from "../components/login/login.component";
import { AuthGuard } from "../services/auth.guard";
import { RoleManagerComponent } from "../components/roleComponents/role-manager/role-manager.component";
import { RoleEditorComponent } from "../components/roleComponents/role-editor/role-editor.component";
import { BhStatsComponent } from "../components/bh-stats/bh-stats.component";
import { NewsEditorComponent } from "../components/news-editor/news-editor.component";
import { PermissionErrorComponent } from "../components/permission-error/permission-error.component";
import { CanDeactivateGuard } from "../guards/can-deactivate.guard";
import { SiteManagementComponent } from "../components/site-management/site-management.component";
import { TagsComponent } from "../components/tags/tags.component";
// import { TranslationServiceToolsEditorComponent } from "../components/translation-service-tools/translation-service-tools-editor/translation-service-tools-editor.component";
const routes: Routes = [
  {
    path: "dashboard",
    component: DashboardComponent,
    canActivate: [AuthGuard],
  },
  { path: "news", component: NewsComponent, canActivate: [AuthGuard] },
  {
    path: "newsEditor/:id",
    component: NewsEditorComponent,
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: "newsEditor",
    component: NewsEditorComponent,
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: "sourceManagement",
    component: SourceManagementComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "tagEdit",
    component: TagsComponent,
    canActivate: [AuthGuard],
  },
  { path: "login", component: LoginComponent },
  {
    path: "userManagement",
    component: UserManagerComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "roleManagement",
    component: RoleManagerComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "userEditor/:id",
    component: UserEditorComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "roleEditor/:id",
    component: RoleEditorComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "sourceManagement/detail/:id",
    component: SourceMappingComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "bh-stats",
    component: BhStatsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "permissionError",
    component: PermissionErrorComponent,
  },
  {
    path: "siteManagement",
    component: SiteManagementComponent,
    canActivate: [AuthGuard],
  },
 /* {
    path: "editTranslationTools",
    component: TranslationServiceToolsEditorComponent,
    canActivate: [AuthGuard],
  },*/
  /* {
    path: 'dashboard',
    component: DashboardComponent,
  },*/
  { path: "", redirectTo: "/news", pathMatch: "full" },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: "reload",
      useHash: true,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}